import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/Users/macmini/Github/Solariis-Intelligence/frontend/dashboard/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/Users/macmini/Github/Solariis-Intelligence/frontend/dashboard/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/Users/macmini/Github/Solariis-Intelligence/frontend/dashboard/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/Users/macmini/Github/Solariis-Intelligence/frontend/dashboard/styles/globals.css");
